import ContainerBox from './ContainerBox';
export default ContainerBox;


// WEBPACK FOOTER //
// ./src/components/ContainerBox/index.js